import { useIntl } from "react-intl";

import Banner from "@components/banners/Banner";

type Props = {
  multipleGoals?: boolean;
};

const EditModeBanner = ({ multipleGoals }: Props) => {
  const intl = useIntl();

  return (
    <Banner
      banner={{
        color: "danger",
        icon: "sealExclamation",
        position: 0,
        subText: intl.formatMessage({ id: "pages.carePlan.base.goals.editModeGoalsBannerSubtext" }),
        text: intl.formatMessage({
          id: multipleGoals
            ? "pages.carePlan.base.goals.editModeGoalsBannerText"
            : "pages.carePlan.base.goals.editModeGoalBannerText"
        })
      }}
      borderRadius
    />
  );
};

export default EditModeBanner;
